module.exports = __webpack_public_path__ + "img/M-logo.c3382d0b.svg";